import {
  BdResourcesSelectInlineConfig,
  CacheService,
  ResourceConfigControlledService,
  ResourceConfigItem,
} from '@bindoc-projects/resource-lib/data';
import {
  BdResourceService,
  BdSharePermission,
} from '@bindoc-projects/resource-domain-lib';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CaseExportTemplateApi } from './case-export-template.api';
import { ExportProperty } from '@bindoc-projects/util-domain-lib';
import {
  CaseExportDefaultTemplate,
  CaseExportTemplate,
  CaseExportTemplateCreate,
} from '@bindoc-projects/virtual-clinic-domain-lib';

export const CASE_EXPORT_TEMPLATE_SELECT_INLINE_CONFIG: BdResourcesSelectInlineConfig<CaseExportTemplate> =
  {
    resourceNameTitle: 'Export Vorlage',
    emptyResourcesText: 'Keine Export Vorlage gefunden',
    detailLinkFnc: (resource) => [
      '/virtual-clinics',
      'case-export-templates',
      resource.id,
    ],
    selectOnInit: 'none',
    disableFnc: () => false,
    filterFnc: () => true,
    resetOption: false,
    minPermission: 'READ',
  };

export class CaseExportTemplateService
  extends ResourceConfigControlledService
  implements BdResourceService<CaseExportTemplate, CaseExportTemplateCreate>
{
  protected _api: CaseExportTemplateApi;

  constructor(
    resourceConfig: ResourceConfigItem,
    environmentService: BdAppEnvironmentService,
    cache: CacheService,
    protected _httpClient: HttpClient,
  ) {
    super(resourceConfig, environmentService, cache);
    this._api = new CaseExportTemplateApi(this.getBaseUrl());
  }

  public exportProperties(): Observable<ExportProperty[]> {
    const url = this._api.exportProperties();
    return this._httpClient.get<ExportProperty[]>(url);
  }

  public defaultTemplates(): Observable<CaseExportDefaultTemplate[]> {
    const url = this._api.exportDefaultTemplates();
    return this._httpClient
      .get<{ displayName: { [lang: string]: string }; properties: string[] }[]>(
        url,
      )
      .pipe(
        map((templates) =>
          templates.map(
            (it) =>
              new CaseExportTemplateCreate(it.displayName['de'], it.properties),
          ),
        ),
      );
  }

  create(toCreate: CaseExportTemplateCreate): Observable<CaseExportTemplate> {
    const url = this._api.caseExportTemplates();
    return this._httpClient
      .post<unknown>(url, toCreate)
      .pipe(map((template) => CaseExportTemplate.fromObject(template)));
  }

  findAll(
    minPermission: BdSharePermission | undefined = undefined,
    companyId?: string,
  ): Observable<CaseExportTemplate[]> {
    const url = this._api.caseExportTemplates();
    let params = new HttpParams();

    if (minPermission) {
      params = params.append('minPermission', minPermission);
    }

    if (companyId) {
      params = params.set('companyId', companyId);
    }

    return this._httpClient
      .get<unknown[]>(url, {
        params,
      })
      .pipe(
        map((templates) =>
          templates.map((template) => CaseExportTemplate.fromObject(template)),
        ),
      );
  }

  findById(id: string): Observable<CaseExportTemplate> {
    const url = this._api.caseExportTemplateById(id);
    return this._httpClient
      .get<unknown>(url)
      .pipe(map((template) => CaseExportTemplate.fromObject(template)));
  }

  update(toUpdate: CaseExportTemplate): Observable<void> {
    const url = this._api.caseExportTemplates();
    return this._httpClient.put(url, toUpdate).pipe(map(() => null));
  }
}
